import lang from "../../lib/appfuse-react/core/lang";
import newborns from "../caseInfo/newborns";

const updateTestDateService = [{
    matcher: 'labNo',
    reply: config => {
        if(config.method==='post') {
            return [200, newborns[0]];
        } else {
            const {predicate} = config.params;
            let data;
            const selector = predicate?.node()?.selector?.();
            const children = predicate?.node()?.children?.();
            if (lang.isNotEmpty(selector)) {
                const value = predicate.node().expectation();
                if(lang.isEmpty(value)) {
                    return [200, newborns];
                }
                if(selector==='hospital' || selector==='uid') {
                    data = newborns.filter(newborn => newborn[selector]===value);
                }
            } else if(lang.isNotEmpty(children)) {
                let tmp = newborns;
                for(let child of children) {
                    const value = child.expectation();
                    if(lang.isEmpty(value)) {
                        continue;
                    }
                    const selector = child.selector();
                     if(selector==='hospital' || selector==='uid') {
                        tmp = tmp.filter(newborn => newborn[selector]===value);
                    }
                }
                data = tmp;
            } else {
                data = newborns;
            }
            return [200, data];
        }
    }
}, {
    matcher: /labNo\/(.*)/,
    reply: config => {
        const id = /labNo\/(.*)/.exec(config.url)[1];
        const newborn = newborns.find(newborn => newborn.no === id);
        return [200, newborn];
    }
}];

export default updateTestDateService;